import { render, staticRenderFns } from "./PayrollExceptionDetail.vue?vue&type=template&id=9f08f16c"
import script from "./PayrollExceptionDetail.vue?vue&type=script&lang=js"
export * from "./PayrollExceptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports